<p>Count of measured iterations:
    {{ task.performance.iterationNumber }}</p>
<p *ngIf="!!task.performance.average">Average iteration time:
    {{ task.performance.average | number : '.2-2' }} s</p>
<p *ngIf="!!task.performance.timeFromStart">Work time: {{ task.timeFromStartStr }}
<p *ngIf="!!task.performance.timeLeft">Time left: {{ task.timeLeftStr }}
</p>
<p *ngIf="!!task.performance.iterationsPerHour">Performance per hour: {{
    task.performance.iterationsPerHour | number
    : '.2-2' }}
</p>
<mat-progress-bar mode="determinate" [value]="task.progress"></mat-progress-bar>
